import { Injectable } from "@angular/core";
import { Store, StoreConfig } from "@datorama/akita";
import { Owners } from "../../../api/nerri/owners/models/owners.model";

export interface RegisterState {
    owner: Owners | null;
    hasRegistered: boolean;
    isLoggedIn: boolean;
    hasValidationError: boolean;
}

const initialState: RegisterState = {
    owner: null,
    hasRegistered: false,
    isLoggedIn: false,
    hasValidationError: false
};

@StoreConfig({ name: "register", resettable: true })
@Injectable()
export class RegisterStore extends Store<RegisterState> {
    constructor() {
        super(initialState);
    }
}
